<img [class]="classImport" [src]="urlLogo"  alt="Logo">

